import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { mdlLanguage } from "../../../models/ui-models/Language";
import _ from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faCircle, faMapLocation, faUsd } from "@fortawesome/free-solid-svg-icons";
import { mdlFactSheetTemplate } from "../../../models/domain/FactSheetTemplate";
import { mdlFactSheetInfo } from "../../../models/domain/FactSheetInfo";
import { Skeleton } from "antd";
import { InputHelper } from "../../../utils/InputHelper";

export type LuxuryTemplateProps = {
    printMode?: boolean;
    data?: mdlFactSheetTemplate;
    selectedHotel?: string;
    selectedLanguage?: mdlLanguage;
}

export const LuxuryTemplate = function LuxuryTemplate(props: LuxuryTemplateProps) {
    const [templateData, setTemplateData] = useState<mdlFactSheetTemplate>();
    const [loader, setLoader] = useState<boolean>(false);
    const { t } = useTranslation();
    useEffect(() => {
        if (props.selectedHotel && !loader) {
            setTemplateData(props.data)
        }
    }, [props]);

    const renderCheckItem = (text: string, hasPrice = false, value : string) => (
        <div className="flex items-center report-line py-1.5 mb-1" style={{position: "relative"}}>
            {hasPrice &&
                <span className="fa-layers" style={{ position: 'absolute', left: '-20px', top: (props.printMode != null ? '13px' : '0'), color: '#B8A88A' }}>
                    <FontAwesomeIcon icon={faCircle} fontSize={35} />
                    <FontAwesomeIcon icon={faUsd} color={"white"} fontSize={10} />
                </span>
            }
            <FontAwesomeIcon icon={faCheck} color="#B8A88A" style={{ marginRight: '10px' }} />
            <span className="text-gray-600 text-sm">{text} { ( !InputHelper.isNullOrUndefinedOrEmpty(value) && value.toLowerCase() != "true" ? ` : ${value}` : "")}</span>
        </div>
    );

    return (
        !templateData ?
        <>
            <Skeleton />
        </>
        :
        <>
            {/* Hotel Info Header */}
            <div className="row g-0 mb-4" style={{width:(props.printMode != null && props.printMode ? '1000px' : 'auto')}}>
                <div className="col-4" style={{ backgroundColor: '#4A3F35' }}>
                    <div className="d-flex flex-column align-items-center justify-content-center py-3">
                        <h1 className="text-white h5 mb-2">{templateData.hotelName}</h1>
                        <div className="d-flex align-items-center report-line">
                            <div className="bg-white" style={{ height: '1px', width: '16px' }}></div>
                            <div className="d-flex">

                                {
                                    templateData && templateData.star &&
                                    Array.from({ length: templateData.star }, (_, index) => (
                                        <span style={{ color: '#fff', fontSize: "25px"  }}>★</span>
                                    ))
                                }
                                {
                                    templateData && templateData.star &&
                                    Array.from({ length: 5 - templateData.star }, (_, index) => (
                                        <span style={{ color: "#B8A88A", fontSize: "25px" }}>★</span>
                                    ))
                                }
                            </div>
                            <div className="bg-white" style={{ height: '1px', width: '16px' }}></div>
                        </div>
                    </div>
                </div>
                <div className="col-8 d-flex align-items-center justify-content-end p-3"
                    style={{ backgroundColor: '#B8A88A' }}>
                    <div className="d-flex align-items-center report-line bg-opacity-25 rounded py-2 pe-2" style={{ border: '2px solid #4A3F35' }}>
                        <span style={{ backgroundColor: '#4A3F35' }}>
                        <FontAwesomeIcon icon={faMapLocation} className="text-white"/>
                        </span>
                        <label className="text-white py-2">{templateData?.hotelLocation}</label>
                    </div>
                </div>
            </div>

            
            {/* Image Gallery */}
            <div className="px-4 mb-4" style={{width:(props.printMode != null && props.printMode ? '1000px' : 'auto')}}>
                <div className="row g-4">
                    {
                        templateData?.images &&
                        templateData?.images.map((_, index) => (
                            <div key={index} className="col-3">
                                <div className="border border-4 border-white rounded shadow-sm"
                                    style={{ aspectRatio: '4/3' }}>
                                    <img
                                        src={_.value}
                                        className="w-100 h-100 object-fit-cover"
                                        style={{width:(props.printMode != null && props.printMode ? '250px' : 'auto')}}
                                    />
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>

            {
                templateData && templateData.list &&
                Array.from(templateData.list.reduce((map, item:mdlFactSheetInfo) => map.set(item.categoryId, item.categoryName), new Map()).values()).map(item =>
                    <div className="px-4" >
                        <div className="mb-4">
                            <h2 className="border-bottom border-2 pb-2 mb-2 h5">
                                <span style={{ color: '#fff', background: '#B8A88A', padding: "5px" }}>
                                {item}
                                </span>
                            </h2>
                            <div className="row" style={{width:(props.printMode != null && props.printMode ? '1000px' : 'auto')}}>
                                {
                                    templateData.list?.filter(x => x.categoryName == item).map((info: mdlFactSheetInfo , subIndex: number) => (
                                        info.questionName &&
                                        <div className="col-3">
                                            {renderCheckItem(info.questionName, info.isExtra, info.value || "")}
                                        </div>
                                    ))
                                }
                            </div>
                        </div>

                        
                    </div>
                )
            }
        </>
    )
}